import { useState, useEffect } from "react";
import ProLayout from "@ant-design/pro-layout";
import { MenuFoldOutlined } from "@ant-design/icons";
import { Outlet, useNavigate } from "react-router-dom";
import { Breadcrumb } from "antd";

import HeaderRight from "./components/header";
import Notification from "./components/notification";
import Nopermission from "@/components/no-permission";

import routes from "@configs/page-routes";
import { proLayoutLogo, proLayoutSettings } from "@configs/theme";
import useAuth from "@/hooks/useAuth";
import breadcrumbsConfig from "@/configs/breadcrumbs";

import styles from "./main-layout.module.less";

export default () => {
  const [collapsed, setCollapsed] = useState(false);

  const nav = useNavigate();

  const { isPermission, access, getMenuRoutes } = useAuth();
  useEffect(() => {
    if (document.title !== "Vendor Portal") {
      // @ts-ignore
      gtag("config", "G-3VHGVRJPPJ");
    }
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.target.nodeName === "TITLE") {
          // @ts-ignore
          gtag("config", "G-3VHGVRJPPJ");
        }
      });
    });

    // 传入目标节点和观察选项并开始观察
    observer.observe(document.querySelector("title") as any, {
      attributes: true,
      childList: true,
      subtree: true,
    });
    return () => {
      observer.disconnect();
    };
  }, []);
  return (
    <ProLayout
      logo={collapsed ? proLayoutLogo.collapsed : proLayoutLogo.expanded}
      disableMobile
      collapsedButtonRender={false}
      collapsed={collapsed}
      route={getMenuRoutes(routes, access)}
      menu={{ defaultOpenAll: true, autoClose: false }}
      menuItemRender={(item: any, dom: any) => {
        return <div onClick={() => nav(`${item.path}`)}>{dom}</div>;
      }}
      contentStyle={{ marginLeft: collapsed ? "36px" : 0 }}
      {...proLayoutSettings}
    >
      <div className={styles.header}>
        <div
          className={styles.collapseIcon}
          onClick={() => setCollapsed(!collapsed)}
        >
          <MenuFoldOutlined className={collapsed ? styles.collapsed : ""} />
        </div>
        <div className={styles.headerContent}>
          <div className={styles.headerLeft}>
            <Breadcrumb
              items={
                breadcrumbsConfig[
                  window.location.pathname as keyof typeof breadcrumbsConfig
                ] || []
              }
            />
          </div>
          <HeaderRight />
          <Notification />
        </div>
      </div>
      <div className={styles.mainContainer}>
        {isPermission ? <Outlet /> : <Nopermission />}
      </div>
    </ProLayout>
  );
};
